// import * as types from './action-types';
import { DashboardProxy } from '../../../proxies';

/* ------------------------ @ACTIONS FOR MAIN CONTENT ----------------------- */
export default function (_module) {

  const getDatas = (payload, type) => {
    return dispatch => new Promise((resolve, reject) => {
      return new DashboardProxy(payload.filter).getAll(payload).then(response => {

        if(payload && payload.key){
          dispatch({ type: `SET_${_module.toUpperCase()}_DATA`, payload: { key: payload.key, data: response } });
        }

        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  };

  const getData = (payload, type) => {
    return dispatch => new Promise((resolve, reject) => {
      return new DashboardProxy(payload.filter).getSingle(payload).then(response => {
        
        if(payload && payload.key){
          dispatch({ type: `SET_SINGLE_${_module.toUpperCase()}_DATA`, payload: { key: payload.key, data: response } });
        }

        resolve(response);
      }).catch((error) => {
        if (!((error && error.description && error.description.includes('could not be found')) || (error && error.description && error.description.includes("Not found.")))) {
          reject(error);
        } 
      });
    });
  };

  const addData = (payload, type) => {
    return dispatch => new Promise((resolve, reject) => {
      dispatch({ type: 'SET_SAVING', payload: { data: 'saving' } });
      return new DashboardProxy(payload.filter).add(payload).then(response => {
        dispatch({ type: `ADD_${_module.toUpperCase()}_DATA`, payload: { key: payload.key, data: response } });
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  };

  const addImage = (payload, type) => {
    return dispatch => new Promise((resolve, reject) => {
      dispatch({ type: 'SET_SAVING', payload: { data: 'saving' } });
      return new DashboardProxy().addImage(payload).then(response => {
        dispatch({ type: `ADD_${_module.toUpperCase()}_IMAGE`, payload: { key: payload.key, data: response } });
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  };

  const updateData = (payload, type) => {
    return dispatch => new Promise((resolve, reject) => {
      dispatch({ type: 'SET_SAVING', payload: { data: 'saving' } });
      return new DashboardProxy().update(payload, type).then(response => {
        dispatch({ type: `UPDATE_${_module.toUpperCase()}_DATA`, payload: { data: response, key: payload.key, index: payload.index } });
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  };

  const deleteData = (payload, type) => {
    return dispatch => new Promise((resolve, reject) => {
      dispatch({ type: 'SET_SAVING', payload: { data: 'saving' } });
      return new DashboardProxy(payload.filter).delete(payload, type).then(response => {
        if(payload.key){
          dispatch({ type: `DELETE_${_module.toUpperCase()}_DATA`, payload: { key: payload.key, index: payload.index } });
        }
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  };

  return {
    getDatas,
    getData,
    addData,
    updateData,
    deleteData,
    addImage
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/global/actions.js